module.exports = __webpack_public_path__ + "static/media/trump-icon.b3d2cac4.png";